<div class="d-flex justify-content-start">
  <img
    src="../assets/img/PCMILER_Logo.svg"
    class=""
    width="100"
    alt="PC*MILER"
  />
  <h4 class="ml-3 my-1">{{ routeName }} Reports</h4>
</div>
